export const buildFetchLoggedUserApiConfig = () => ({
    url: '/api/user-profile/me',
    method: 'GET',
});
